import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";

const urlPrefix = "/api/v2/chatapp/user-chat";

export interface IChatInfo {
  chatId: string;
  _id: string;
  user: {
    mobileNo: string;
    name: string;
    _id: string;
  };
  botMode: boolean;
  botName: string;
  status: string;
  chatInitiatorAgent: {
    name: string;
    email: string;
  };
  currentAgent: {
    agentId: string;
    email: string;
    name: string;
  };
  currentOwner: string;
  businessType: string;
}

const initailState: IChatInfo = {
  chatId: "",
  _id: "",
  user: {
    mobileNo: "",
    name: "",
    _id: ""
  },
  status: "",
  chatInitiatorAgent: { name: "", email: "" },
  botMode: false,
  botName: "",
  currentAgent: {
    agentId: "",
    email: "",
    name: ""
  },
  currentOwner: "",
  businessType: ""
};

const slice = createSlice({
  name: "chatsInfo",
  initialState: initailState,
  reducers: {
    chatInfoReceived: (state, action) => {
      state = action.payload;
      return state;
    }
  }
});

export const { chatInfoReceived } = slice.actions;

export const loadChatInfo = (payload: any) => {
  return apiCallBegan({
    url: `${urlPrefix}/get-chat-info?chatId=${payload.chatId}`,
    headers: {
      "Cache-Control": "no-cache"
    },
    method: "GET",
    onSuccess: chatInfoReceived.type,
    resolve: payload.resolve,
    reject: payload.reject
  });
};

export default slice.reducer;
